import React from 'react';
import { BaseText } from './BaseText';
import { defineFontSettings } from './fontSettings';

export const Body1 = (props) => {
  const { children } = props;
  const fontSettings = defineFontSettings(
    { fontSize: '14px', lineHeight: '20px' },
    { fontSize: '18px', lineHeight: '24px' }
  );
  return (
    <BaseText fontSettings={fontSettings} {...props}>
      {children}
    </BaseText>
  );
};
